const containerTransportContainerDetails = {
	"container.transport.container.containerDetails.eido": "PIN",
	"container.transport.container.containerDetails.requestedFullDelivery": "Requested Full Pickup from Terminal",
	"container.transport.container.containerDetails.requestedEmptyPickup": "Requested Full Delivery to Unpack Location",
	"container.transport.container.containerDetails.requestedEmptyDelivery": "Requested Empty Delivery to Pack Location",
	"container.transport.container.containerDetails.requestedFullPickup": "Requested Full Delivery to Terminal"
};

export { containerTransportContainerDetails };
